import {
  BASE_PATH_ANALYTICS,
  BUTTONS_ANALYTICS,
  MODE_ANALYTICS,
} from '@/constants/analytics'
import {
  createAnalyticsManifest,
  EventDispatcherConfig,
} from '@/services/analytics'

export const eventDispatcherConfig = (isMfp: boolean): EventDispatcherConfig =>
  ({
    config: {
      screenName: 'CloudValueProp',
      screenPath: BASE_PATH_ANALYTICS.PORTAL_OOBE,
    },
    defaultData: {
      screenMode: isMfp
        ? MODE_ANALYTICS.MULTI_FUNCTION
        : MODE_ANALYTICS.SINGLE_FUNCTION,
    },
  }) as const

export const CloudValuePropPageAnalytics = createAnalyticsManifest(
  eventDispatcherConfig,
  ({ dispatcher }) => ({
    fireContinueButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.CONTINUE,
      })
    },
    fireSkipButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.SKIP,
      })
    },
  }),
)
